
import './forceDebug';
import './forceDesktop';
import './underMaintenance';

// auth
import './auth/loginjwt';
import './auth/confirm/confirm';
import './auth/forgot/forgot';
import './auth/register/register';
import './auth/login/login';
import './auth/set-password/set-password';
import './auth/reset/reset';
import './auth/tfa/tfa';

// dashboard
import './root/root';
import './dashboard/dashboard';
import './dashboard/body/body';
import './dashboard/navigation/navigation';
import './dashboard/body/content/device-details/device-details';
import './dashboard/body/content/devices/devices';
import './dashboard/body/content/my-account/my-account';
import './dashboard/body/content/products/products';
import './dashboard/body/content/service-details/service-details';
import './dashboard/body/content/store/store';
import './dashboard/body/content/subscriptions/subscriptions';
import './dashboard/body/content/news/news';
import './dashboard/body/content/news/article';
import './dashboard/body/content/support/support';
import './dashboard/body/content/homepage/homepage';
import './dashboard/body/content/print-gdpr-report/print-gdpr-report';
import './dashboard/body/content/crypto/crypto';
import './dashboard/body/content/us-compliance-failed/us-compliance-failed';
import './dashboard/body/content/dwm/dwm';


// landing pages
import './landing-pages/not-allowed/not-allowed';

// modals
import './modals/critical-error/critical-error';
import './modals/activation-confirmation';
import './modals/applockplus';
import './modals/base';
import './modals/change-lang/change-lang';
import './modals/lock-device';
import './modals/MarketingCard';
import './modals/register';
import './modals/remove-device';
import './modals/session-expire';
import './modals/subscriptionConfirmation';
import './modals/one-click-payment';
import './modals/ocp-comparison';
import './modals/device/lock-device/lock-device';
import './modals/device/unlock-device/unlock-device';
import './modals/my-account/crop-image/crop-image';
import './modals/my-account/change-email/change-email-modal';
import './modals/my-account/password-confirmation/password-confirmation';
import './modals/my-account/delete-account-confirmation/delete-account-confirmation';
import './modals/my-account/get-report/get-report';
import './modals/welcome-modal/welcome-modal';
import './modals/welcome-modal-spotlight/welcome-modal-spotlight';
import './modals/language-switcher/language-switcher';
import './modals/store-product-card/product-card';
import './modals/add-payment/add-payment';
import './modals/payment-cart/payment-cart';
import './modals/store-trial-card/trial-card';
import './modals/gdpr-report/gdpr-report';
import './modals/confirm-login/confirm-login';
import './modals/threats-landscape/threats-landscape';
import './modals/coinbase-account/coinbase-account';
// DWM
import './modals/dwm/bank-accounts/bank-accounts';
import './modals/dwm/credit-cards/credit-cards';
import './modals/dwm/addresses/addresses';
import './modals/dwm/phone-numbers/phone-numbers';
import './modals/dwm/emails/emails';
import './modals/dwm/mothers-name/mothers-name';
import './modals/dwm/drivers-license/drivers-license';
import './modals/dwm/insurance-cards/insurance-cards';
import './modals/dwm/gamer-tags/gamer-tags';
import './modals/dwm/notifications/notifications';
import './modals/dwm/dwm-upsell/dwm-upsell';
import './modals/dwm/toggle-monitoring/toggle-monitoring';
// Trial modal
import './modals/trial-modal/trial-modal';

// export default angular.module('controllers').controller('Register', Register).name;



// WEBPACK FOOTER //
// ./scripts/controllers/index.js